
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M16.7 5.30001L18.14 3.86001C18.46 3.54001 18.23 3.01001 17.79 3.01001H11.5C11.22 3.01001 11 3.23001 11 3.51001V9.80001C11 10.25 11.54 10.47 11.85 10.15L13.3 8.70001C15.27 10.16 16.55 12.48 16.55 15.12C16.55 15.78 16.47 16.43 16.31 17.04C16.19 17.54 16.79 17.9 17.15 17.53C18.63 16 19.55 13.92 19.55 11.62C19.55 9.11001 18.44 6.86001 16.7 5.30001Z' fill='#323232'/><path d='M12.15 13.86L10.7 15.3C8.73001 13.84 7.45001 11.52 7.45001 8.88C7.45001 8.22 7.53001 7.57 7.69001 6.96C7.81001 6.46 7.21001 6.1 6.85001 6.47C5.37001 8 4.45001 10.08 4.45001 12.38C4.45001 14.9 5.55001 17.15 7.29001 18.71L5.85001 20.15C5.53001 20.47 5.76001 21 6.20001 21H12.49C12.77 21 12.99 20.78 12.99 20.5V14.21C13 13.77 12.46 13.54 12.15 13.86Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-wifi-protected-setup`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWifiProtectedSetup

    ```js
    <b-new-b-icon-wifi-protected-setup />
    ```
</docs>


